var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationPinGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 64,
    viewBox: "0 0 34 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 55,
    r: 8,
    stroke: "#373737",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 55,
    r: 5,
    fill: "#373737"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 17.4549C33 26.5427 24.7241 34.2292 17 56C9.82759 34.8021 1 26.5427 1 17.4549C1 8.36712 8.16344 1 17 1C25.8366 1 33 8.36712 33 17.4549Z",
    fill: "#54CD84",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinGreen);
export default __webpack_public_path__ + "static/media/location-pin-green.310c7194b96314d1343ab8a25c5c5c39.svg";
export { ForwardRef as ReactComponent };